import { render } from "./OwnersForCargo.vue?vue&type=template&id=e2701290&scoped=true"
import script from "./OwnersForCargo.vue?vue&type=script&lang=js"
export * from "./OwnersForCargo.vue?vue&type=script&lang=js"

import "./OwnersForCargo.vue?vue&type=style&index=0&id=e2701290&scoped=true&lang=css"
import "./OwnersForCargo.vue?vue&type=style&index=1&id=e2701290&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2701290"]])

export default __exports__